export default __webpack_public_path__ + "static/media/user-profile-icon.b720d2cf.svg";